import { escapeQueryStringValue } from './escapeQueryStringValue';

/**
 * query_string clause matching every typed token as a substring of any of the
 * given fields: tokens are ANDed, fields are ORed per token.
 * Returns `''` for blank input.
 */
export const buildPartialMatch = (fields: string[], value: string): string => {
  const tokenClauses = value
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map(token => {
      const escaped = escapeQueryStringValue(token);
      const perField = fields.map(field => `${field}:*${escaped}*`);
      return perField.length === 1 ? perField[0] : `(${perField.join(' OR ')})`;
    });

  if (!tokenClauses.length) return '';
  return tokenClauses.length === 1 ? tokenClauses[0] : `(${tokenClauses.join(' AND ')})`;
};

export default buildPartialMatch;
